module.exports = __webpack_public_path__ + "media/images/ninestars/about-img-4c20470dce80ae8710130f0e8ee48188.svg";